import React from 'react';
import DateRangeReportTable from '../../components/DateRangeReportTable';
import {
    amountBodyTemplate,
    bankPaymentStatusBodyTemplate,
    createPaymentMethodTemplate,
    dateTimeBody
} from '../../../../utils/tableTemplates';

const COLUMNS = [
    {field: 'policyNumber', header: 'Policy Number', sortable: true},
    {field: 'productName', header: 'Product Name', sortable: true},
    {field: 'payerName', header: 'Payer Name', sortable: true},
    // Hidden in the table only; the column stays defined so the CSV/PDF exports still include it.
    {field: 'mobileNumber', header: 'Mobile Number', hidden: true},
    {field: 'emailAddress', header: 'Email', hidden: true},
    {field: 'serialNumber', header: 'Serial Number', sortable: true},
    {field: 'paymentMethod', header: 'Payment Method', body: createPaymentMethodTemplate(), sortable: true},
    {field: 'amount', header: 'Amount', body: amountBodyTemplate, sortable: true},
    {field: 'paymentStatus', header: 'Payment Status', body: bankPaymentStatusBodyTemplate, sortable: true},
    {field: 'paymentReference', header: 'Payment Ref', hidden: true},
    {field: 'notes', header: 'Notes'},
    {field: 'timeStamp', header: 'Timestamp', body: dateTimeBody('timeStamp'), sortable: true},
];

const LABELS = {
    notFound: 'Agent not found.',
    failure: 'Failed to fetch agent reports. Please try again.',
    success: 'Agent reports loaded successfully',
    emptyMessage: 'No payment records found. Please select a date range and generate report.',
};

const AgentReportsTable = () => (
    <DateRangeReportTable
        title="All Agents Report"
        exportName="Agent Payments"
        endpoint="report/agents"
        param={{name: 'agentId', label: 'Agent ID', numeric: true}}
        columns={COLUMNS}
        labels={LABELS}
    />
);

export default AgentReportsTable;
